$(document).ready(function() {
    let elem = $('.image-lazy-load').find('.itemImage');
    for(var i=0; i<=elem.length;i++){
        get_images(elem[i]);
    }
    /*var lazyElements = [].slice.call(document.querySelectorAll(".image-lazy-load"));
    if ("IntersectionObserver" in window) {
        let lazyElementObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    let Elem = entry.target;
                    get_images(Elem);
                    // get_phone_number(Elem);
                    // get_flavor_match(Elem)

//                    Elem.classList.remove("image-lazy-load");
//                    lazyElementObserver.unobserve(Elem);
                }
            });
        });
        console.log("lazyelements...", lazyElements.length);
        lazyElements.forEach(function(lazyImage) {
            lazyElementObserver.observe(lazyImage);
        });
    } else {
        // Possibly fall back to a more compatible method here
    }*/
     loadItemImages(); //calling this is a hack because sometimes above is not getting all images 21300
    $('.full-image-container button').unbind('click').bind('click', function(){
        const linkImage = $(this).attr('data-link');
        const div = $('<div></div>').addClass('full-screen topmost image-container-full');
        const button_close = $('<button class="btn close-view" title="Close">x</button>');
        const image = $('<img src='+ linkImage +'></img>');
        div.append(image);
        button_close.on('click', function(){
            div.remove();
        });

        div.append(button_close);
        $('body').append(div);
    })

    $('.venue-number-phone').each(function() {
        const id = $(this).attr('id');
        if(id) {
            $.get('/fetchVenuePhone', { venueId: id}).done(function(data) {
                if (data.contact) {
                    const contact = data.contact
                    $(this).attr('href', `tel: +1 ${contact.formattedPhone || contact.phone || ''}`).text(contact.formattedPhone || contact.phone || '');
                }
            }.bind(this));
        }
    });

    $('.full-image-container button').unbind('click').bind('click', function(){
        const linkImage = $(this).attr('data-link');
        const div = $('<div></div>').addClass('full-screen topmost image-container-full');
        const button_close = $('<button class="btn close-view" title="Close">x</button>');
        const image = $('<img src='+ linkImage +'></img>');
        div.append(image);
        button_close.on('click', function(){
            div.remove();
        });

        div.append(button_close);
        $('body').append(div);
    })
});

function loadItemImages() {
	$('.itemImage:not(.loading-complete)').each(function() {
        const imageType = $(this).attr('img-type');
        const id = $(this).attr('id');
        const googleFlag = $("#googleFlag").val();
    const venueId = $(this).attr('venue-id');

    //console.log("in loadItemImages for id...",id, imageType, venueId); 
        $.get('/fetchItemImages', { itemId: id, imageType : imageType, googleFlag: googleFlag, venueId: venueId }).done(function(data) {
			$(this).addClass('loading-complete');
            if (data.found && data.links && data.links.length > 0) {
                var img = data.links[0];
                $(this).attr('src', img);
                if (img){
                    $(this).parents('.item-image-container').find('.full-image-container button').attr('data-link', img);
                } else {
                    $(this).parents('.item-image-container').find('.full-image-container button').remove();
                }
            } else {
                $(this).parents('.item-image-container').find('.full-image-container button').remove();
            }
        }.bind(this));
    });
}

// List of funtions that used for lazy load

function get_images(root_elem){

    let elem = root_elem;
    const imageType = $(elem).attr('img-type');
    const id = $(elem).attr('id');
    const venueId = $(elem).attr('venue-id');
    const googleFlag = $("#googleFlag").val();

//    console.log("in get_images...",id, imageType, venueId);

    $.get('/fetchItemImages', { 
        itemId: id, 
        imageType : imageType, 

        googleFlag: googleFlag,
        venueId: venueId
    })
    .done(function(data) {
      try{
        data = JSON.parse(data);
      } catch(err){
//        console.log("not valid json for images...", data, id);
      }
      if (data && data.links) {
        var links = data.links[id];
        if (links && links.length > 0) {
            var img;
            for (var i = 0; i < links.length; i++) {
                if (links[i].isDefault === true) {
                    img = links[i].url;
                    break;
                }
            }
            if (!img) {
                img = links[0].url;
            }
            $(elem).attr('src', img);
        } else {
            // console.log("links exist, yet images not found for id...", id, JSON.stringify(data));
        }
    } else {
        // console.log(" images not found for id...", id, JSON.stringify(data));
    }
    })
}

function get_phone_number(elem){
    let venue_id = $(elem).find('#venue-id').val();
    if(!venue_id) return false;
    elem = $(elem).find('.venue-number-phone');
    $.get('/fetchVenuePhone', { venueId: venue_id})
    .done(function(data) {
        if (!data.contact) return false;
        const contact = data.contact
        $(elem).attr('href', `tel: +1 ${contact.formattedPhone || contact.phone || ''}`).text(contact.formattedPhone || contact.phone || '');
    });
}

function get_flavor_match(elem){
    let venue_id = $(elem).find('#venue-id').val();
    elem = $(elem).find('.item-flavor-match');
    let item_id = $(elem).data('item-id');
    if(!venue_id || !item_id) return false;
    $.post('/item/flavor-match', { venueId: venue_id, itemId: item_id})
    .done(function(data) {
        if(!data) return false;
        elem.html(`<i class="fa fa-heart" aria-hidden="true"></i> Flavor Match: ${data.match}%`)
    });
}
